import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = [{
    title: 'Buscar un buen terapeuta es una odisea:',
    desc: 'No es fácil encontrar a alguien con quien conectes de verdad.'
  }, {
    title: 'Los costos son prohibitivos:',
    desc: 'Pagar cuatro o cinco sesiones al mes hoy es un presupuesto que destruye cualquier economía.'
  }, {
    title: 'El "autocuidado" de internet no sirve:',
    desc: 'Te dicen que te des un baño de espuma o prendas una vela, pero tu cabeza sigue a mil por hora.'
  }, {
    title: 'Te guardás todo:',
    desc: 'Ignorás tus emociones incómodas hasta que terminás explotando por el estrés.'
  }, {
    title: 'Límites inexistentes:',
    desc: 'Decís que "sí" a todo el mundo por miedo a quedar mal, postergándote siempre a vos primero.'
  }];
  return <section className="py-12 md:py-16 bg-white" data-id="element-208">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-10" data-id="element-210">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-dark mb-6 leading-tight" data-id="element-211">
            ¿Cuánto tiempo más vas a seguir postergando tu bienestar mental?
          </h2>
          <p className="text-lg md:text-xl text-dark-light leading-relaxed max-w-3xl mx-auto" data-id="element-212">
            Sentís que la cabeza no para. Te gustaría recuperar la calma y
            sentirte mejor. Querés vivir con menos ansiedad. Pero seguramente te
            pasa esto:
          </p>
        </motion.div>

        <div className="space-y-4 mb-10" data-id="element-213">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-cream rounded-2xl border border-cream-dark hover:shadow-md transition-shadow" data-id="element-214">
              <XCircle className="w-7 h-7 text-coral flex-shrink-0 mt-1" data-id="element-215" />
              <div data-id="element-216">
                <span className="font-bold text-dark text-lg md:text-xl block mb-1" data-id="element-217">
                  {point.title}
                </span>
                <span className="text-dark-light text-base md:text-lg" data-id="element-218">
                  {point.desc}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-coral/10 p-8 rounded-3xl border-2 border-coral/20" data-id="element-219">
          <p className="text-2xl md:text-3xl font-display font-bold text-dark mb-2" data-id="element-220">
            No es falta de capacidad.
          </p>
          <p className="text-xl md:text-2xl text-coral-dark font-medium" data-id="element-221">
            Es que nadie te enseñó un sistema claro, científico y cotidiano para
            gestionar lo que sentís.
          </p>
        </motion.div>
      </div>
    </section>;
}